import { Box, Typography } from "@mui/material";
import Container from "../components/Common/Container";
import Title from "../components/Common/Title";

const About = () => {
  return (
    <Container>
      <Box py="6rem">
        <Title fTitle="About" lTitle="Us" />
        <Typography variant="subtitle1" pt="1rem" align="center">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit
          consequatur maiores laudantium, dolore minima magni ipsa tempore
          officia praesentium autem dolor blanditiis qui labore saepe sint sequi
          molestias minus expedita distinctio. Illo culpa eaque inventore hic
          repellendus, enim doloribus eius aspernatur suscipit, odio iusto, vel
          sint dolore iure repellat a dolorem optio autem quisquam sunt. Enim
          reprehenderit aut rem cumque tenetur, hic fugiat eaque corrupti! Quia
          libero animi perferendis reprehenderit officiis laborum tempore, optio
          est repellat ad inventore ex deserunt, fuga exercitationem quibusdam
          error? Eum asperiores in voluptatibus similique explicabo! Et illo
          consectetur similique optio perferendis tempora velit quae mollitia
          accusamus alias inventore deleniti odit porro dolorum minus dolorem
          eveniet sit nisi temporibus nemo saepe corrupti est, dignissimos
          obcaecati. Voluptatibus hic magni, porro recusandae eos vel quibusdam
          laborum pariatur consectetur unde, dolor incidunt, qui provident dicta
          repellendus aliquam fugit officiis? Veritatis, incidunt consequatur?
          Quaerat, consequatur veritatis doloribus exercitationem enim aliquid!
        </Typography>
      </Box>
    </Container>
  );
};

export default About;
